export enum ReportStatus {
  None,
  New,
  Updated,
  ComingSoon
}
